// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_on-0";
export var buttonContainer = "_on-3";
export var cancelButton = "_on-4";
export var headerSection = "_on-6";
export var headerTitle = "_on-9";
export var messageSideLeft = "_on-1";
export var messageSideRight = "_on-2";
export var orderNumberContainer = "_on-7";
export var orderNumberLabel = "_on-8";
export var submitButton = "_on-5";